import { useIntl, setLocale, } from 'umi';
import { useState, useCallback } from 'react';
// import type { UseLangOptions, LangFunction, TtFunction, UseLangReturn } from './interface';

type UseLangOptions = string | string[];

export interface LangFunction {
  (id: string, values?: Record<string, any> & { defaultMessage?: string} | string): string;
}

export interface TtFunction {
  (module: string): LangFunction;
}

export interface TttFunction {
  (id: string, values?: Record<string, any> & { defaultMessage?: string} | string): string;
}

export interface UseLangReturn {
  t: LangFunction;
  tt: TtFunction;
  ttt: TttFunction;
}

const useLang = (modules?: UseLangOptions): UseLangReturn => {
  const intl = useIntl();
  const moduleArray = typeof modules === 'string' ? [modules] : modules || [];
  const module = moduleArray[0];
  const t = useCallback<LangFunction>((id, values) => {
    const options = typeof values === 'string' ? { defaultMessage: values } : values;
    const messageId = module ? `${module}:${id}` : id;

    try {
      const result = intl.formatMessage(
        { id: messageId, defaultMessage: options?.defaultMessage },
        options && typeof options === 'object' ? options : undefined
      );
      return result !== messageId ? result : (options?.defaultMessage || id);
    } catch (e) {
      return options?.defaultMessage || id;
    }
  }, [module, intl]);

  const tt = useCallback<TtFunction>((targetModule) => {
    return (id, values) => {
      const options = typeof values === 'string' ? { defaultMessage: values } : values;
      const messageId = `${targetModule}:${id}`;

      try {
        const result = intl.formatMessage(
          { id: messageId, defaultMessage: options?.defaultMessage },
          options && typeof options === 'object' ? options : undefined
        );

        return result !== messageId ? result : (options?.defaultMessage || id);
      } catch (e) {
        return options?.defaultMessage || id;
      }
    };
  }, [intl]);

  const ttt = useCallback<TttFunction>((id, values) => {
    let isMatched = false;
    let matchResult = '';
    const options = typeof values === 'string' ? { defaultMessage: values } : values;
    for (const module of moduleArray) {
      const messageId = `${module}:${id}`;
      try {
        const result = intl.formatMessage(
          // 这里不能传defaultMessage, 否则无法判断是否匹配到值（如果defaultMessage 与匹配到的值一样时）
          { id: messageId, },
          options && typeof options === 'object' ? options : {}
        );
        // debugger
        if (result && result !== messageId) {
          if (isMatched) {
            console.warn(`Duplicate key '${id}' found in module '${module}'.`);
          }
          isMatched = true;
          matchResult = result
        }
      } catch (e) {
        // Continue to try the next module
      }
    }

    return isMatched ? matchResult : (options?.defaultMessage || id);
  }, [moduleArray, intl]);

  return {
    t,
    tt,
    ttt,
  };
};

/** 支持多模块划分
 * 
*/
export const useModuleLang = (modules: string[]): LangFunction[] => {
  const { tt } = useLang()

  let handlers: LangFunction[] = []
  for (const module of modules) {
    // console.log('module: ', module)
    handlers.push(tt(module))
  }
  return handlers
};

export default useLang;